export const getPricePerMonth = (price, discount = 0) => {
  return Math.floor((price - discount) / 100 / 12) * 100;
};

export const getPricePerDay = (price, discount = 0) => {
  return Math.floor((price - discount) / 100 / 365) * 100;
};
